module.exports = __webpack_public_path__ + "img/ic-instagram.1d36ef86.svg";